(function () {
  function initialize(root = document) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-sacred-reveal]')).filter(function (item) {
      return !item.classList.contains('is-reveal-ready') && !item.classList.contains('is-revealed');
    });
    if (!items.length) return;

    var observer;
    try {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -10% 0px', threshold: 0.12 }
      );
    } catch (error) {
      return;
    }

    items.forEach(function (item) {
      item.classList.add('is-reveal-ready');
      try {
        observer.observe(item);
      } catch (error) {
        item.classList.remove('is-reveal-ready');
      }
    });
  }

  initialize();
  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
})();
